import { Avatar, AvatarProps } from 'antd';
import { FC } from 'react';
import { ReactSVG } from 'react-svg';

export const ILSAvatar: FC<AvatarProps> = (props) => {
  return <Avatar icon={<ReactSVG src={'/assets/icons/user.svg'} />} {...props} />;
};
